import './PracticeDiscovery.scss'

import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Container, Card, Col, Row } from 'react-bootstrap'
import {
  EVENT_CATEGORY_PRACTICES,
  EVENT_ACTION_PAGEVIEW,
  saveUserEvent
} from '../../common/api/UserEvents'
import { getAllPracticesDetails } from '../../common/api/Practices'
import { navigateTo } from '../../common/navigation'
import { getAuthenticatedUser } from 'components/auth'
import PracticesInfo from 'components/welcome/PracticesInfo/PracticesInfo'
import { ROUTE_ACTIVITIES_ALL } from 'components/common/helpers/Paths'
import { buildRequestURL } from 'components/common/api'

export default function PracticeDiscovery({ setHeaderTitle, setReturnPath, libraryPage = false, returnPath = ROUTE_ACTIVITIES_ALL }) {
  const history = useHistory()
  const user = getAuthenticatedUser()

  const [practices, setPractices] = useState()

  useEffect(() => {
    // Return early if we don't have a user or if we've already fetched the practices
    if (!user || practices) return

    // Scroll to top
    window.scrollTo(0, 0)

    // Clear out Header title and return path
    setHeaderTitle(null)
    setReturnPath(null)

    // Get all `active` practices
    const filteredPractices = getAllPracticesDetails().filter(
      practice => practice.active
    )

    setPractices(filteredPractices)

    // Log access
    saveUserEvent(EVENT_CATEGORY_PRACTICES, EVENT_ACTION_PAGEVIEW)
  }, [user, practices, setHeaderTitle, setReturnPath])

  return (
    <Container className='practices'>
      {!libraryPage && (
        <h1 className='title'>Find what you need</h1>
      )}
      <Row xs={2} sm={3}>
        {practices?.map((practice, i) => (
          <Col key={practice.key}>
            <Card
              className='practice-discovery-card'
              style={{ animationDelay: `${0.05 * i}s` }}
              onClick={_ => {
                const url = buildRequestURL(practice.path, { returnPath })
                navigateTo(url, history)
              }}
            >
              <div
                className='practice-discovery-preview'
                style={{
                  backgroundImage: `url(${practice.image})`
                }}
              ></div>
              <div
                className='practice-discovery-title'
                style={{ animationDelay: `${0.09 * i}s` }}
              >
                <span>{practice.title}</span>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
      {!libraryPage && (
        <PracticesInfo />
      )}
    </Container>
  )
}
